import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'

// Always use real Firebase services
const isDemoMode = false

// Log mode status
// Firebase Auth: Using Google authentication only

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Validate that we have the correct auth domain format
if (firebaseConfig.authDomain && !firebaseConfig.authDomain.endsWith('.firebaseapp.com')) {
  // Auth domain should be in format "projectId.firebaseapp.com"
}

// Debug: Log config values (without sensitive info)
// Firebase Config Check: apiKey, authDomain, projectId, appId validated

// Validate required config
const requiredConfig = ['apiKey', 'authDomain', 'projectId', 'appId']
const missingConfig = requiredConfig.filter(key => {
  const value = firebaseConfig[key as keyof typeof firebaseConfig]
  return !value
})

if (missingConfig.length > 0) {
  // Missing Firebase configuration error logged
  throw new Error(`Missing Firebase configuration: ${missingConfig.join(', ')}`)
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize Firebase Auth following the official documentation pattern
export const auth = getAuth(app)

// Legacy exports - set to null to maintain compatibility
export const db = null
export const storage = null
export const functions = null
export const messaging = null
export const analytics = null

export { isDemoMode }

// Connect to auth emulator in development (if emulators are enabled)
const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true'
if (import.meta.env.DEV && useEmulators) {
  const hostname = 'localhost'
  
  try {
    // Only connect if not already connected
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    if (!(auth as any).config?.emulator) {
      connectAuthEmulator(auth, `http://${hostname}:9099`, { disableWarnings: true })
      // Connected to Auth emulator at localhost:9099
    }
  } catch (error) {
    // Ignore "already connected" errors
    const errorMessage = error instanceof Error ? error.message : String(error)
    if (!errorMessage.includes('already')) {
      // Auth emulator connection failed - error logged
    }
  }
}

// Service availability checks
export const isAuthAvailable = () => true
export const isFirestoreAvailable = () => false
export const isStorageAvailable = () => false
export const isFunctionsAvailable = () => false
export const isMessagingAvailable = () => false
export const isAnalyticsAvailable = () => false

// Firebase initialized successfully with auth service only

if (!useEmulators && import.meta.env.DEV) {
  // Using REAL Firebase Auth
  // Google Sign-In ready
}